/** "512 B", "1.5 KB", "10 MB": one decimal, dropped when it is zero. */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return oneDecimal(bytes / 1024) + " KB";
  return oneDecimal(bytes / (1024 * 1024)) + " MB";
}

function oneDecimal(value: number): string {
  return value.toFixed(1).replace(/\.0$/, "");
}
